export const MOBILE = 500;
export const TABLET = 768;
export const DESKTOP = 960;
